import { defineComponent } from "vue";
import Loading from "@/baseui/loading/loading.vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "newDisc",
  props: {
    newDiscList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter();
    var date = Date.now();
    /* 点击专辑跳转详情 */

    var albumClick = function albumClick(id) {
      router.push("/main/albumdetail/".concat(id));
    };

    return {
      date: date,
      albumClick: albumClick
    };
  },
  components: {
    Loading: Loading
  }
});